import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../../images/image_empty_error.png';

export default function PrintStockRedirect({ event, menhirUrl }) {
    return (
        <div>
            <WeezHeader title={<Trans i18nKey="attendees.printStock.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={<Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={`${menhirUrl}/canaux_impression.php?id_evenement=${event.id}`} />}
            />
        </div>
    );
}

PrintStockRedirect.propTypes = {
    event: PropTypes.object.isRequired,
    menhirUrl: PropTypes.string.isRequired
};
